<template>
  <div class="home-container" :class="{'new-distance':!isInNative}">
    <div class="shop-header">
      <EntitySecond :itemData="storeInfo"/>
      <Nav :navData="menuInfo"/>
    </div>

    <template v-if="tipTitle">
      <div style="padding: 10px 0;">
        <placeholder
          slot="no-results"
          :icon="tipIcon"
          :title="tipTitle"
        />
      </div>
    </template>
    <template v-else>
      <div v-for="({componentIndex,componentNeedData},index) in cardComponentList" :key="index">
        <component :is="componentIndex"
                   :data="componentNeedData"
                   v-if="(
                       componentNeedData.items && componentNeedData.items.length>0
                       || componentNeedData.cardType == 40601
                       || componentNeedData.cardType == 0)"></component>
        <div class="g-bottom-divider"
             v-if="(componentNeedData.cardType ===40301||componentNeedData.cardType ===40401)
             &&componentNeedData.items[0]
             &&componentNeedData.items[0].itemType!==30501
             &&(index!==cardComponentList.length-1)"></div>
      </div>

      <div class="loading" v-if="isLoading">
        <zs-spinner ref="spinner"/>
        <span style="font-size: 15px">&nbsp;&nbsp;加载中...</span>
      </div>

      <div class="bottom-footer" v-if="cardList.length > 1">没有更多内容了</div>
    </template>
  </div>
</template>

<script>
  import Api from "../../service/api"
  import Cookies from 'js-cookie'
  import pv from '../../service/pingback/pv'
  import global from '../../components/Global'
  import Nav from '../../components/cards/Nav'
  import store from "../../store";
  import {mapGetters} from 'vuex'
  import EntitySecond from '../../components/items/Entity2'
  import Placeholder from '@/components/placeholder.vue'
  // import ZsSpinner from "../../components/spinner/index";
  // import Toast from '../../widget/toast'
  // import homeData from './mock'

  export default {
    components: {
      Nav,
      EntitySecond,
      Placeholder
    },
    data() {
      return {
        pageData: {},
        cardList: [],
        cardComponentList: [],
        isLoading: false,
        isInNative: false,
        tipIcon: 'play',
        tipTitle: ''
      }
    },

    async mounted() {
      // Toast.info('enter....')
      try {
        window.scrollTo(0, 0)

        this.isLoading = true
        let param = this.$route.params.pageId;
        let arr = []
        if (param) {
          arr = param.split('.html');
          await this.getHomeData(arr[0]);
        }
        this.$store.dispatch('category/home', true)
        this.isLoading = false
      } catch (err) {
        this.isLoading = false
      }
    },

    methods: {
      async getHomeData(pageKey) {
        const homeData = await Api.read(pageKey, 'home');
        if (!homeData) {
          return
        }

        this.pageData = homeData && homeData.pages[0];
        this.cardList = this.pageData && this.pageData.cards || [];
        // 学员作品数据放进传给组件的数据里
        for (const key in this.cardList) {
          if (this.cardList[key].contentType === 'HOMEWORK' && homeData.homeworkList) {
            this.cardList[key].homeworkList = homeData.homeworkList
          }
        }
        this.cardComponentList = this.$renderCardComponentList(this.cardList);
        if (homeData.coupons) {
          this.$global.coupons = homeData.coupons
        }

        let docTitle = homeData.storeInfo && homeData.storeInfo.name || '知识店铺'
        this.$store.dispatch('category/setNvTitle', '知识店铺')
        //存储店铺和菜单数据
        document.title = '爱奇艺知识'
        const channel = this.$getParameterByName("social_platform")
        if (channel) {
          // global.channel = this.$getUrlParamsArr("social_platform").pop();
          global.channel = channel
        }
        let homePageUrl = homeData && homeData.extend && homeData.extend.homePageUrl;

        if (homePageUrl) {
          Cookies.set('homePageUrl', homePageUrl + "&social_platform=" + global.channel);
        }
        Cookies.set('lastPage', location.href);
        let qiyiId = homeData && homeData.extend && homeData.extend.qiyiId;
        if (qiyiId) {
          Cookies.set('qiyiId', qiyiId)
        }

        // let shopTitle = this.cardList && this.cardList[0]
        //   && this.cardList[0].items && this.cardList[0].items[0]
        //   && this.cardList[0].items[0].showData
        //   && this.cardList[0].items[0].showData.texts
        //   && this.cardList[0].items[0].showData.texts[0]
        //   && this.cardList[0].items[0].showData.texts[0].text || '知识店铺';
        const shopId = homeData && homeData.storeInfo && homeData.storeInfo.key || " ";
        const storeInfo = (homeData && homeData.storeInfo) || {};

        window.pageTitle = docTitle
        window.storeInfo = storeInfo
        let opt = {
          rpage: `knowledge_h5_shop_${shopId}_${docTitle}`,
          v: 1,
          shop_id: shopId
        }
        pv.send(opt);
        Cookies.set('shopTitle', shopId);

        // 存储店铺和菜单信息
        store.dispatch('category/storeInfo', {
          storeInfo: homeData && homeData.storeInfo || {}
        })
        store.dispatch('category/menuInfo', {
          menuInfo: homeData && homeData.tabs || []
        })

        try {
          const pages = homeData.pages || []
          if (!pages[0]) {
            pages[0] = {cards: []}
          }
          const cards = pages[0].cards || []
          if (cards.length === 0) {
            this.tipTitle = '店铺还没有课程哦'
          }
        } catch (err) {}

        return homeData
      },
    },
    computed: {
      ...mapGetters('category', {
        storeInfo: 'getStoreInfo',
        menuInfo: 'getMenuInfo'
      }),
    },
    created() {
      this.$store.dispatch('category/home', true);
      // this.shopData = shopData
      // if(this.storeInfo.key){
      //     pv.send({
      //         rpage:`knowledge_h5_shop_${this.storeInfo.key}_全部课程`,
      //     })
      // }
      if (window.browser.iqiyi || window.browser.knowledge) {
        this.isInNative = true
      }
    },
  }
</script>

<style lang="less">
  .home-container {
    .zs-infinite-loading-container {
      background-color: #fff;
      padding-bottom: 10px;
    }

    .loading {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &.view {
      margin-top: 0px;
    }

    &.new-distance {
      margin-top: -14px !important;
    }
  }

</style>
